"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickBuyButtonWrapper = exports.NotifyMeIconButton = exports.IconWrapper = exports.IconButtonWithFixedSize = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const IconWrapper = exports.IconWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  position = 'bottom'
}) => ({
  alignItems: 'end',
  bottom: position === 'bottom' ? theme.spacing(2) : 'initial',
  top: position === 'top' ? theme.spacing(2) : 'initial',
  display: 'flex',
  flexDirection: 'column-reverse',
  padding: theme.spacing(0, 2),
  position: 'absolute',
  right: 0,
  zIndex: 2,
  gap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(2)
  }
}));
const IconButtonWithFixedSize = exports.IconButtonWithFixedSize = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['buttonSize', 'iconSize'])
})(({
  buttonSize,
  iconSize,
  theme
}) => ({
  height: buttonSize,
  width: buttonSize,
  '& svg': {
    fontSize: iconSize
  },
  [theme.breakpoints.up('sm')]: {
    height: buttonSize,
    width: buttonSize,
    '& svg': {
      fontSize: iconSize
    }
  }
}));
const NotifyMeIconButton = exports.NotifyMeIconButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    height: 45,
    width: 45,
    fontSize: '2.7rem'
  }
}));
const QuickBuyButtonWrapper = exports.QuickBuyButtonWrapper = (0, _mui.styled)('div')({
  display: 'flex'
});
